<template>
      <custom-dialog
        width="500px"
        class="maintain-cycle-dialog"
        :title="model.title"
        :visible="visible"
        :appendToBody="true"
        v-on="$listeners"
      >
      <div class="dialog-body">
        <!-- 表单 -->
        <el-form :model="form" :inline="true" size="small" ref="form"  label-position="top">
          <el-row>
            <el-col :span="24">
              <el-form-item :label="$t('asm_maintain_cycle_dialog.bao_yang_jian_ge_shi')" prop="maxUsageHour" :rules="rules.maxUsageHour">
                <el-input  v-model="form.maxUsageHour" style="width: 440px"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$t('asm_maintain_cycle_dialog.bytqtxsxs')"
                prop="hourWarnTime"
                :rules="rules.hourWarnTime"
              >
                <el-input
                  type="number"
                  v-model.number="form.hourWarnTime"
                  style="width: 440px"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$t('asm_maintain_cycle_dialog.zcbyjgt')"
                prop="maxUsageDay"
                :rules="rules.maxUsageDay"
              >
                <el-input type="number"  v-model.number="form.maxUsageDay" style="width: 440px"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$t('asm_maintain_cycle_dialog.zcbytqtxsxt')"
                prop="dayWarnTime"
                :rules="rules.dayWarnTime"
              >
                <el-input
                  type="number"
                  v-model.number="form.dayWarnTime"
                  style="width: 440px"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$t('asm_maintain_cycle_dialog.bygdcsqxs')"
                prop="upkeepOrderTimeout"
                :rules="rules.upkeepOrderTimeout"
              >
                <el-input type="number" v-model.number="form.upkeepOrderTimeout" style="width: 440px"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">{{$t('Common.com_cancel')}}</el-button>
        <el-button size="small" type="primary" @click="confirm">{{$t('Common.com_confirm')}}</el-button>
      </div>
    </custom-dialog>

</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';
import languageInjectMixins from '@/mixins/language_inject_mixins';

export default {
  mixins: [dialogMixins, languageInjectMixins],

  data() {
    return {
      item: {},
      // visible: false,
      form: {
        productCode: '',
        maxUsageDay: 0,
        maxUsageHour: 0,
        upkeepOrderTimeout: 0,
        dayWarnTime: 0,
        hourWarnTime: 0
      },
    };
  },
  mounted() {
    this.initDialog();
  },

  computed: {
    rules() {
      return {
        maxUsageHour: [{ required: true, message: this.$t('asm_maintain_cycle_dialog.qtxbyjg') }],
        maxUsageDay: [{ required: true, message: this.$t('asm_maintain_cycle_dialog.qtxzcbyjg') }],
        upkeepOrderTimeout: [{ required: true, message: this.$t('asm_maintain_cycle_dialog.qtxbygdcsqx') }]
      };
    },
  },
  methods: {
    // 初始化
    initDialog: function () {
      // this.$nextTick(() => {
      // this.visible = true;
      // });
      if (this.model.type === 'edit') {
        this.item = this.model.data;
        this.$setFormatData(this.form, this.model.data);
        this.form.productCode = this.model.data.productCode;
      }
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },
    // 确认保存
    confirm: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        if (this.form.dayWarnTime && (this.form.dayWarnTime > this.form.maxUsageDay)) {
          this.$message.error(this.$t('asm_maintain_cycle_dialog.zcbytqtxsxbndyzcbyjg'));
          return;
        }
        if (this.form.hourWarnTime && (this.form.hourWarnTime > this.form.maxUsageHour)) {
          this.$message.error(this.$t('asm_maintain_cycle_dialog.bytqtxsxbndybyjg'));
          return;
        }
        if (this.model.type === 'edit') {
          this.saveUpdate();
        }
      });
    },
    // 保存编辑
    saveUpdate: function () {
      this.$postJSON(apis.UpkeepCycleSave, this.form).then(() => {
        this.$message({
          message: this.$t('Common.com_edit_success'),
          type: 'success'
        });
        this.closeDialog();
        this.$emit('success', this.form);
      });
    }
  }
};
</script>

<style lang="scss">
.maintain-cycle-dialog {
}
</style>
